<template>
  <div>
    <!-- <h1>Standortimport</h1> -->
    <!-- This component displays the import data and allow the user to fix errors -->
    <!-- ******************* -->
    <!-- *     Toolbar     * -->
    <!-- ******************* -->
    <!-- This is the panel on top of the page where buttons are displayed -->
    <div class="panel panel-default" id="import-top-panel">
      <div class="panel-body">
        <div class="col-md-5">
          <!-- Add control buttons here  -->
          <button
            class="btn btn-raised btn-top-bar"
            :disabled="!noErrors && selectedRowNumbers.length == 0"
            @click="saveImportData()"
          >
            <i class="material-icons md-36">check</i>
            <br />
            {{ lang.I0000 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            :disabled="noErrors"
            @click="validateImportData()"
          >
            <i class="material-icons md-36">redo</i>
            <br />
            {{ lang.I0001 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            @click="cancelLocationImport()"
          >
            <i class="material-icons md-36">clear</i>
            <br />
            {{ lang.I0002 }}
          </button>
        </div>

        <!-- Counter -->
        <div class="well col-md-2 well-counter">
          {{ lang.I0033 }}: {{ selectedRowNumbers.length }}
          <br />
          {{ lang.I0034 }}: {{ serverResponse.Error_Counter }}
          <br />
          {{ lang.I0035 }}: {{ serverResponse.Updated_Counter }}
          <br />
          {{ lang.I0036 }}: {{ serverResponse.Inserted_Counter }}
        </div>

        <div class="col-md-5">
          <!-- Add filter buttons here  -->
          <button
            class="btn btn-raised btn-top-bar color-error"
            @click="(errorFilterState = !errorFilterState), (selectedPage = 1)"
          >
            <i v-if="errorFilterState" class="material-icons md-36"
              >check_box</i
            >
            <i v-else class="material-icons md-36">check_box_outline_blank</i>
            <br />
            {{ lang.I0003 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar color-new"
            @click="(newFilterState = !newFilterState), (selectedPage = 1)"
          >
            <i v-if="newFilterState" class="material-icons md-36">check_box</i>
            <i v-else class="material-icons md-36">check_box_outline_blank</i>
            <br />
            {{ lang.I0004 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar color-updated"
            @click="
              (updatedFilterState = !updatedFilterState), (selectedPage = 1)
            "
          >
            <i v-if="updatedFilterState" class="material-icons md-36"
              >check_box</i
            >
            <i v-else class="material-icons md-36">check_box_outline_blank</i>
            <br />
            {{ lang.I0005 }}
          </button>
        </div>
      </div>

      <div class="panel-body">
        <div class="col-lg-5"></div>

        <div class="col-lg-2">
          <a
            role="button"
            class="btn btn-raised color-info"
            :disabled="selectedRowNumbers.length == 0"
            @click="selectedRowNumbers = []"
            style="margin-top: 6px"
            >{{ lang.I0037 }}</a
          >
          <!-- <a role="button" class="btn btn-raised" v-else @click="selectAllRows()" style="margin-top: 6px;">
            Alle auswählen
          </a>-->
        </div>

        <div class="col-lg-5 nopadding">
          <!-- Pagination -->
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <!-- Dropdown: Select the number of elements per page -->
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.I0030 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <!-- Add dropdown entries here -->
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                    >500</a
                  >
                </li>
              </ul>
            </li>

            <!-- Jump to first page -->
            <li
              v-bind:class="{ disabled: selectedPage == 1 }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.I0031 }}</b-tooltip
              >
            </li>
            <!-- ... -->
            <li v-if="pageCount > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <!-- Pagenumbers -->
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <!-- ... -->
            <li
              v-if="pageCount > 7 && selectedPage < pageCount - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <!-- Jump to last page -->
            <li
              v-bind:class="{ disabled: selectedPage == pageCount }"
              @click="updatePaging(pageCount, 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.I0032 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Table      * -->
    <!-- ******************* -->
    <!-- This is the main panel on the page where all input data is displayed in a table -->
    <div class="panel panel-default">
      <div class="panel-body table-responsive import-table-panel">
        <table style="width: auto" class="table table-striped table-hover">
          <thead>
            <tr>
              <template v-if="tableHeaders.length > 1">
                <th
                  v-for="header in tableHeaders"
                  :key="header"
                  class="text-center"
                  style="white-space: nowrap"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="
                      (sortColumn = header), (sortOrderAsc = !sortOrderAsc)
                    "
                  >
                    {{ header }}
                    <span
                      v-if="sortColumn == header && sortOrderAsc"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortColumn == header && !sortOrderAsc"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
              </template>
              <th v-else>{{ lang.I0038 }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              role="button"
              v-for="(location, rowindex) in serverResponse.Locations"
              :key="rowindex"
              @click="toggleRowSelected(rowindex)"
              v-bind:class="{
                info: isRowSelected(rowindex),
                'color-error': rowContainsError(rowindex),
                'color-new': isRowNew(rowindex) && !rowContainsError(rowindex),
                'color-updated':
                  isRowUpdated(rowindex) && !rowContainsError(rowindex),
              }"
            >
              <td
                v-for="(value, column) in getVisibleLocationData(location)"
                :key="column"
              >
                <div
                  v-if="isErrorValue(rowindex, column)"
                  class="form-group nopadding error-input"
                >
                  <input
                    type="text"
                    class="form-control text-center nopadding"
                    readonly="true"
                    onblur="this.readOnly='true';"
                    ondblclick="this.readOnly='';"
                    v-model="serverResponse.Locations[rowindex][column]"
                  />
                </div>
                <div v-else>{{ value }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Modal      * -->
    <!-- ******************* -->
    <!-- This modal is used for user feedback on different tasks of the component -->
    <div
      class="modal fade"
      id="feedbackModal"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>{{ feedbackModalData.title }}</b>
            </h4>
          </div>
          <div class="modal-body" v-html="feedbackModalData.text"></div>
          <!-- Cancel import buttons -->
          <div
            v-if="feedbackModalData.type == 'YesNoCancelImport'"
            class="modal-footer"
          >
            <button type="button" class="btn btn-raised" data-dismiss="modal">
              {{ lang.I0006 }}
            </button>
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="discardImportData()"
            >
              {{ lang.I0007 }}
            </button>
          </div>

          <!-- Import successful button -->
          <div
            v-if="feedbackModalData.type == 'okImportSuccessful'"
            class="modal-footer"
          >
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="exitImport()"
            >
              {{ lang.I0008 }}
            </button>
          </div>

          <!-- No action -> for information display only -->
          <div
            v-if="feedbackModalData.type == 'okNoAction'"
            class="modal-footer"
          >
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              data-dismiss="modal"
            >
              {{ lang.I0008 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocationImport",
  created() {
    let guidRegex = RegExp(
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
    );

    if (guidRegex.test(this.$route.params.clientGuid))
      this.selectedClient = this.$route.params.clientGuid;
    else {
      this.globals.showErrorSnackbar(this.lang.I0039);
      this.$router.push({
        path: `/locationmanagement`,
      });
    }
  },
  mounted() {
    // Gets executed right after rendering the component
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    let error = () => {
      this.$router.push({
        path: `/locationmanagement`,
      });
    };
    this.getCurrentImportData(error);

    $(window).on("resize", this.setTableHeight).resize();

    $("#feedbackModal").on("hide.bs.modal", () => {
      this.checkForErrors = false;
      this.initialRender = false;
    });
  },
  destroyed() {
    $(window).off("resize", this.setTableHeight);
  },
  methods: {
    setTableHeight() {
      let height = $(window).height();
      height -=
        $("#import-top-panel").height() + $("#app-navbar").height() + 47; // 47 pixel for the free space around the cards
      $(".import-table-panel").css("max-height", height);
    },
    // Display some information dialog to let the user know what to do, depending on whether there are errors or not
    showInitialMessages() {
      if (this.noErrors) {
        this.feedbackModalData.type = "okNoAction";
        this.feedbackModalData.title = this.lang.I0009;
        this.feedbackModalData.text = this.lang.I0010;
        this.feedbackModalData.text += this.lang.I0011;
        this.feedbackModalData.text += this.lang.I0012;
      } else {
        this.feedbackModalData.type = "okNoAction";
        this.feedbackModalData.title = this.lang.I0013;
        this.feedbackModalData.text = this.lang.I0014;
        this.feedbackModalData.text += this.lang.I0015;
        this.feedbackModalData.text += this.lang.I0016;
        this.feedbackModalData.text += this.lang.I0017;
        this.feedbackModalData.text += this.lang.I0018;
      }
      $("#feedbackModal").modal("show");
    },
    // Display information about errors that are still available
    showErrorCheckMessages() {
      if (this.serverResponse.Error_Counter < 1) {
        // No more errors left
        this.feedbackModalData.type = "okNoAction";
        this.feedbackModalData.title = this.lang.I0023;
        this.feedbackModalData.text = this.lang.I0024;
        this.feedbackModalData.text += this.lang.I0025;
        $("#feedbackModal").modal("show");
      } else {
        // Still errors left
        this.feedbackModalData.type = "okNoAction";
        this.feedbackModalData.title = this.lang.I0026;
        this.feedbackModalData.text = this.lang.I0027;
        $("#feedbackModal").modal("show");
      }
    },
    // Toggles the selected-state of a given row, if it does not contain errors.
    // If the row is not yet selected, it will be added to the array of selected rows.
    // If the row is already selected, it will be removed from that array.
    toggleRowSelected(index) {
      if (this.rowContainsError(index)) return;
      let idx = this.selectedRowNumbers.indexOf(
        this.serverResponse.Locations[index].RN
      );
      if (idx > -1) this.selectedRowNumbers.splice(idx, 1);
      else
        this.selectedRowNumbers.push(this.serverResponse.Locations[index].RN);
    },
    // Selects all available rows
    // selectAllRows() {
    //   let rowNumbers = this.getRange(1, this.serverResponse.Count, 1);
    //   this.selectedRowNumbers = rowNumbers;
    // },
    // Returns true if row is selected, otherwise false.
    isRowSelected(index) {
      return (
        this.selectedRowNumbers.indexOf(
          this.serverResponse.Locations[index].RN
        ) > -1
      );
    },
    // Returns true if given datarow is updated, otherwise false.
    isRowUpdated(index) {
      return this.serverResponse.Locations[index].state === "U";
    },
    // Returns true if given datarow is new, otherwise false.
    isRowNew(index) {
      return this.serverResponse.Locations[index].state === "I";
    },
    // Closes the import and returns to the client management
    exitImport() {
      $("#feedbackModal").modal("hide");
      this.$router.push({
        path: `/locationmanagement`,
      });
    },
    // Sends a message to the server to store the import data in the database
    saveImportData() {
      if (this.noErrors || this.selectedRowNumbers.length > 0) {
        let dataString = '{"save":true';

        if (this.selectedRowNumbers.length > 0)
          dataString +=
            ',"selected":' + JSON.stringify(this.selectedRowNumbers);
        dataString += "}";

        // Send data to the server
        $.ajax({
          method: "POST",
          url: `api/Locations/Import/${this.selectedClient}`,
          data: dataString,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            this.globals.showSuccessSnackbar(this.lang.I0020);
            this.$router.push({
              path: `/locationmanagement`,
            });
          },
          error: () => {
            console.error("Error on POST in saveImportData()");
            this.globals.showErrorSnackbar(this.lang.I0022);
          },
        });
      } else
        console.error("Error on saveImportData(): There are still errors left");
    },
    // Sends corrected import data to the server to check, if the new data is valid
    validateImportData() {
      let dataString = '{"corrections":';

      let correctionData = [];
      for (
        let locIdx = 0;
        locIdx < this.serverResponse.Locations.length;
        locIdx++
      ) {
        if (this.serverResponse.Locations[locIdx].ErrorColumnNames)
          // Build data structure
          for (
            let errIdx = 0;
            errIdx <
            this.serverResponse.Locations[locIdx].ErrorColumnNames.length;
            errIdx++
          ) {
            let obj = {};
            obj.RN = this.serverResponse.Locations[locIdx].RN;
            obj.ColumnName = this.serverResponse.Locations[
              locIdx
            ].ErrorColumnNames[errIdx];
            obj.Value = this.serverResponse.Locations[locIdx][obj.ColumnName];

            correctionData.push(obj);
          }
      }

      dataString += JSON.stringify(correctionData) + "}";
      $.ajax({
        method: "POST",
        url: `api/Locations/Import/${this.selectedClient}`,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.checkForErrors = true;
          this.getCurrentImportData();
          this.globals.showSuccessSnackbar(this.lang.I0040);
        },
        error: () => {
          console.error("Error on POST in validateImportData()");
          this.globals.showErrorSnackbar(this.lang.I0041);
        },
      });
    },
    // Returns a string that contains all parameters for the request containing paging and filter states
    getRequestParamString() {
      let getString = "?page_size=" + this.pageSize;
      getString += "&page=" + this.selectedPage;
      getString += "&sort_order=" + (this.sortOrderAsc ? "asc" : "desc");
      if (this.sortColumn) getString += "&sort_column=" + this.sortColumn;

      if (
        this.errorFilterState ||
        this.newFilterState ||
        this.updatedFilterState
      ) {
        getString += "&filter={";
        if (this.errorFilterState)
          getString += '"Errors":' + this.errorFilterState;

        if (
          this.errorFilterState &&
          (this.newFilterState || this.updatedFilterState)
        )
          getString += ",";

        if (this.newFilterState || this.updatedFilterState) {
          getString += '"States":[';

          if (this.newFilterState) {
            getString += '"I"';
            if (this.updatedFilterState) getString += ',"U"';
          } else {
            if (this.updatedFilterState) getString += '"U"';
          }
          getString += "]";
        }
        getString += "}";
      }
      return getString;
    },
    // Requests importdata for the current page with the current settings from the server
    getCurrentImportData(error) {
      let getString = `api/Locations/Import/${this.getRequestParamString()}`;
      getString = encodeURI(getString);

      $.ajax({
        method: "GET",
        url: getString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.pageSize = data[0].Page_Size;
          this.selectedPage = data[0].Page;
          this.pageCount = data[0].Page_Count;
          this.serverResponse = data[0];
          this.noErrors = !this.errorsExist();
          this.tableHeaders = this.getTableHeaders();

          if (this.initialRender) {
            // Only executes the first time after component rendering
            this.showInitialMessages();
            if (
              this.serverResponse.Error_Counter +
                this.serverResponse.Updated_Counter +
                this.serverResponse.Inserted_Counter ==
              0
            ) {
              this.errorFilterState = false;
              this.updatedFilterState = false;
              this.newFilterState = false;
            }
          }

          if (this.checkForErrors) {
            // Only executes after data validation
            this.showErrorCheckMessages();
            if (
              this.serverResponse.Error_Counter +
                this.serverResponse.Updated_Counter +
                this.serverResponse.Inserted_Counter ==
              0
            ) {
              this.errorFilterState = false;
              this.updatedFilterState = false;
              this.newFilterState = false;
            }
          }
        },
        error: () => {
          console.error("Error on GET in getCurrentImportData()");
          this.globals.showErrorSnackbar(this.lang.I0042);
          if (error) error();
        },
      });
    },
    // Tells the server to discard the import data
    discardImportData() {
      let dataString = '{"save":false}';

      $.ajax({
        method: "POST",
        url: `api/Locations/Import/${this.selectedClient}`,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.exitImport();
        },
        error: () => {
          console.error("Error on POST in discardImportData()");
          this.globals.showErrorSnackbar();
        },
      });
    },
    // Displays a security check dialog if the user tries to cancel the import
    cancelLocationImport() {
      this.feedbackModalData.type = "YesNoCancelImport";
      this.feedbackModalData.title = this.lang.I0028;
      this.feedbackModalData.text = this.lang.I0029;
      $("#feedbackModal").modal("show");
    },
    // Returns true, if the row with the given index contains an error value, otherwise false
    rowContainsError(index) {
      if (this.noErrors) return false;

      if (this.serverResponse.Locations[index].ErrorColumnNames) return true;
      return false;
    },
    // Returns true, if the field with the given rowindex and columnname contains an error, otherwise false
    isErrorValue(rowindex, column) {
      if (!this.rowContainsError(rowindex)) return false;

      if (
        this.serverResponse.Locations[rowindex].ErrorColumnNames.indexOf(
          column
        ) > -1
      )
        return true;
    },
    // Returns true if there are errors in the server response, otherwise false
    errorsExist() {
      if (!this.serverResponse.Error_Counter) return false;
      return this.serverResponse.Error_Counter > 0;
    },
    // Returns a list of header names for the table
    getTableHeaders() {
      if (!this.serverResponse || !this.serverResponse.Locations) return [""];
      let headers = Object.keys(this.serverResponse.Locations[0]);

      // Remove columns that do not have to be shown
      let idx;
      let removeCols = ["RN", "state", "ErrorColumnNames"];
      for (let i = 0; i < removeCols.length; i++) {
        idx = headers.indexOf(removeCols[i]);
        if (idx !== -1) headers.splice(idx, 1);
      }
      return headers;
    },
    getVisibleLocationData(location) {
      return _.pick(location, this.tableHeaders);
    },
    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getCurrentImportData();
    },
    // Returns a range of numbers with min-value, max-value and stepsize
    getRange(min, max, step) {
      let range = [],
        j = 0;
      for (let i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (
        this.pageCount > 7 &&
        this.selectedPage >= this.pageCount - 3
      ) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
  },
  watch: {
    errorFilterState() {
      this.getCurrentImportData();
    },
    newFilterState() {
      if (!(this.initialRender || this.checkForErrors))
        this.getCurrentImportData();
    },
    updatedFilterState() {
      if (!(this.initialRender || this.checkForErrors))
        this.getCurrentImportData();
    },
    sortColumn() {
      this.getCurrentImportData();
    },
    sortOrderAsc() {
      this.getCurrentImportData();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  data() {
    // Global data inside the component is stored here
    return {
      selectedClient: "",
      serverResponse: [], // Stores the server response data
      pageSize: 20, // Number of locations on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      sortOrderAsc: true,
      sortColumn: "",
      noErrors: false, // true --> there are currently no errors in the import data
      tableHeaders: [],
      errorFilterState: true, // Stores the current state of the error-filter
      newFilterState: true, // Stores the current state of the new-filter
      updatedFilterState: true, // Stores the current state of the updated-filter
      checkForErrors: false,
      initialRender: true,
      selectedRowNumbers: [], // Stores the index of the selected table-row
      feedbackModalData: {
        type: "info", // Should be "okNoAction", "okImportSuccessful" or "YesNoCancelImport" -> different dialog types
        title: "", // Set the dialog title here
        text: "", // Set the dialog text here
      },
      lang: {
        I0000: "Save",
        I0001: "Send correction",
        I0002: "Cancel import",
        I0003: "Error",
        I0004: "Add",
        I0005: "Updated",
        I0006: "No",
        I0007: "Yes",
        I0008: "OK",
        I0009: "Import data were successfully verified.",
        I0010: "The data were successfully verified and free of error!<br><br>",
        I0011: "The imported data can be seen in the following table.<br>",
        I0012: 'For writing the data to the database click <b>"Save"</b>.<br>',
        I0013: "Check import data",
        I0014: "Please check the data to be imported.<br><br>",
        I0015:
          "In all lines marked in yellow errors are highlighted in red.<br>",
        I0016: "The incorrect inputs can only be edit by double clicking.<br>",
        I0017:
          'For resending the revised data click <b>"Send correction"</b>.<br>',
        I0018:
          'By clicking <b>"Activate filter"</b> only faulty records will be shown.<br>',
        I0019: "Import was successful",
        I0020: "Data were successfully imported.",
        I0021: "Import failed",
        I0022: "An error occurred while importing!",
        I0023: "Correction was successful",
        I0024:
          "The data were successfully verified and free of further errors!<br><br>",
        I0025: 'For writing the data to the database click <b>"Save"</b>.<br>',
        I0026: "Incorrect correction",
        I0027:
          "Sorry, but there are still errors in the import data. Please correct them!",
        I0028: "Cancel import",
        I0029: "Do you really want to cancel the import?",
        I0030: "Items per page",
        I0031: "First page",
        I0032: "Last page",
        I0033: "Selected",
        I0034: "Incorrect",
        I0035: "Updated",
        I0036: "Add",
        I0037: "Clear selection",
        I0038: "No data",
        I0039: "Invalid client",
        I0040: "Import data update successful",
        I0041: "Import data update failed",
        I0042: "Import data access failed",
      },
    };
  },
};
</script>

<style scoped>
/* Main table */
table {
  table-layout: fixed; /* fixed size */
  word-wrap: break-word;
}
.table-header {
  color: #004080; /* color for table header elements */
}
.import-table-panel {
  /* allows scrolling inside the panel */
  max-height: auto;
  overflow-y: scroll;
}

/* Buttons appearance */
.btn-top-bar {
  margin: 16px 8px 16px 8px;
}

/* Space between buttons for counter display */
.well-counter {
  height: 100px;
  margin: 5px 0px 0px 0px;
  padding: 10px;
}

/* Background colors */
.error-input {
  background-color: #ff9999;
}

.color-error {
  background-color: #ffff99 !important;
}
.color-error:hover {
  background-color: #ffffcc !important;
}

.color-updated {
  background-color: #e6ccff !important;
}
.color-updated:hover {
  background-color: #f3e6ff !important;
}

.color-new {
  background-color: #b3ffd9 !important;
}
.color-new:hover {
  background-color: #ccffe6 !important;
}

.color-info {
  background-color: #d9edf7 !important;
}
.color-info:hover {
  background-color: #c4e3f3 !important;
}
</style>



// WEBPACK FOOTER //
// LocationImport.vue?9a4294a0